var exports = {
  "uW": "PricingSection.module__section___Q0NCVH",
  "E3": "PricingSection.module__toggleContainer___Q0NCVH",
  "xQ": "PricingSection.module__footerContainer___Q0NCVH",
  "$P": "PricingSection.module__scrollPromptContainer___Q0NCVH",
  "Zq": "PricingSection.module__scrollPromptText___Q0NCVH",
  "$O": "PricingSection.module__scrollPromptIcon___Q0NCVH",
};

module.exports = exports;
